module.exports = __webpack_public_path__ + "static/media/SB2018.ed419e05.jpg";